import { useAppSelector } from "@/redux/hooks";
import { useSplitTreatments } from "@splitsoftware/splitio-react";

export const useGuestCheckoutEnabled = (retailerId?: number) => {
  const userProfile = useAppSelector((state) => state.userProfile);
  const appConfig = useAppSelector((state) => state.appConfig);
  const { treatments } = useSplitTreatments({
    names: ["brandclub_guest_checkout"],
    attributes: {
      email: userProfile?.email ?? "",
      appId: appConfig?.brandAppConfig?.appId ?? "",
      checkoutBrandId: appConfig?.brandAppConfig?.checkoutBrandId ?? "",
      appType: appConfig?.brandAppConfig?.appType ?? "",
      retailerId: retailerId ?? 0,
    },
  });

  const experimentEnabled =
    treatments["brandclub_guest_checkout"].treatment === "experiment";

  const enabledGuestCheckout =
    treatments["brandclub_guest_checkout"].treatment === "on" ||
    experimentEnabled;

  return {
    enabledGuestCheckout,
    experimentEnabled,
  };
};
